import { MarkAnimationTiming } from './MarkAnimationTiming';

/**
 * Animation type for a group of marks.
 * C++ Reference: AnimationType enum in tabanim
 */
export enum AnimationType {
  EnterFadeOn = 'EnterFadeOn',
  DirectMove = 'DirectMove',
  ExitFadeOff = 'ExitFadeOff',
}

/**
 * Animation parameters for a group of marks (enter, move, exit, or non-marks).
 * Contains an overall timing plus optional per-attribute timing overrides.
 *
 * C++ Reference: MarkAnimationParams in tabanim/main/sceneanimation/MarkAnimationParams.h
 */
export class MarkAnimationParams {
  overallTiming: MarkAnimationTiming;
  animationType: AnimationType;
  attributeTimingOverrideMap: Map<string, MarkAnimationTiming>;

  constructor(overallTiming: MarkAnimationTiming, animationType: AnimationType) {
    this.overallTiming = overallTiming.clone();
    this.animationType = animationType;
    this.attributeTimingOverrideMap = new Map();
  }

  setAttributeOverrideTiming(attr: string, timing: MarkAnimationTiming): void {
    this.attributeTimingOverrideMap.set(attr, timing.clone());
  }

  clearAttributeOverrideTiming(attr: string): void {
    this.attributeTimingOverrideMap.delete(attr);
  }

  clearAllAttributeOverrideTiming(): void {
    this.attributeTimingOverrideMap.clear();
  }

  clone(): MarkAnimationParams {
    const result = new MarkAnimationParams(this.overallTiming, this.animationType);
    this.attributeTimingOverrideMap.forEach((timing, attr) => {
      result.attributeTimingOverrideMap.set(attr, timing.clone());
    });
    return result;
  }

  toDebugString(): string {
    return `[${this.animationType}|${this.overallTiming.toDebugString()} overrides=${this.attributeTimingOverrideMap.size}]`;
  }
}
